import { useLocation } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { fetchComments, updateComments } from "../../api/community";
import { Button, Pagination, Table, Flex, Select, Space, Input, Popconfirm, Tag, Tooltip, message, DatePicker, Popover } from "antd";
import { EyeFilled,  PlusOutlined } from "@ant-design/icons";
import { useDebouncedCallback } from "use-debounce";
import dayjs from "dayjs";
import { RichText } from "@chatui/core";
import '../../style/community.css';
import UserInfoView from "../../components/community/user_info_view";
import PostReview from "../../components/community/post_review";
import { PostStatusOptions } from "../../components/community/post_pageview";
import VirtualCommentModalView from "../../components/community/virtual_comment_modal_view";

const CommentsScreen = () => {
    const location = useLocation();
    const tooltipRef = useRef(null);
    const [currPost, setCurrPost] = useState();
    const tabCols = [
        {
            title: 'Created',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: (text, _) => {
                return <label style={{ fontSize: 12, color: '#afafaf', whiteSpace: 'nowrap' }}>{dayjs(text).format('MM-DD HH:mm')}</label>
            },
        },
        {
            title: 'Comment',
            dataIndex: 'content',
            key: 'content',
            render: (_, record) => {
                return (
                    <div>
                        <UserInfoView user={record.user} showWallet={false} />
                        <div style={{ background: '#f1f1f1', padding: '8px 12px', borderRadius: 8, maxWidth: 240, marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="community-content">
                                {Array.from(record.resources ?? []).length > 0 ? '「IMAGE」' : ''}
                                <RichText content={record.title ? record.title : record.content} />
                            </div>
                            <Popover
                                placement="right"
                                title=''
                                content={
                                    <div className="post-content-review" style={{ maxWidth: 300, maxHeight: 400, overflowY: 'auto' }}>
                                        <RichText content={record.content} />
                                        {
                                            Array.from(record.resources ?? []).map(img => {
                                                return <img key={img.id} alt="addx go comment image" src={img.url} style={{ width: '100%', height: 'auto', marginTop: 8 }} />
                                            })
                                        }
                                    </div>
                                }
                                trigger={'click'}>
                                <EyeFilled style={{ color: 'grey', cursor: 'pointer' }} />
                            </Popover>
                        </div>
                    </div>
                )
            },
        },
        {
            title: 'Related Post',
            dataIndex: 'post',
            key: 'post',
            render: (_, record) => {
                if (!record.post || !record.post?.user) return '-';
                return (
                    <div>
                        <UserInfoView user={record.post?.user} showWallet={false} />
                        <div style={{ background: '#fafafa', padding: '8px 12px', borderRadius: 8, maxWidth: 240, marginTop: 8, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <div className="community-content">
                                <RichText content={record.post.title ? record.post.title : record.post.content} />
                            </div>
                            <EyeFilled style={{ color: 'grey', cursor: 'pointer' }} onClick={() => reviewHandle(record.post)} />
                        </div>
                    </div>
                )
            },
        },
        {
            title: 'Likes',
            dataIndex: 'agreeCount',
            key: 'agreeCount',
            render: (text, _) => {
                if (parseFloat(text) <= 0) return '-';
                return <b>{text}</b>;
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => {
                if (String(text) === '3') {
                    return (
                        <Tooltip ref={tooltipRef} title={record.riskReason} color='orange'>
                            <Tag color="red">RISK</Tag>
                        </Tooltip>
                    )
                } else if (String(text) === '2' || String(text) === '5' || String(text) === '6') {
                    return <Tag style={{ fontSize: 12 }} color="processing">PENDING</Tag>;
                } else if (String(text) === '1') {
                    return <Tag style={{ fontSize: 12 }}>PUBLISHED</Tag>;
                }
                return ''
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            render: (text, record) => {
                return (
                    <Button.Group size='small'>
                        {
                            (String(record.status) === '3' || String(record.status) === '2') &&
                            <Button type='link' onClick={() => { revokeHandle(record) }}>Revoke</Button>
                        }
                        <Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this comment?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm>
                    </Button.Group>
                )
            },
        }
    ];

    const [searchParams, setSearchParams] = useState({
        content: '',
        userKeyword: '',
        status: undefined,
        level: undefined,
        start: '',
        end: ''
    });
    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [currComment, setCurrComment] = useState();

    useEffect(() => {
        fetchData(pageNum, pageSize, searchParams);
    }, [location])

    const fetchData = (pNum, pSize, search) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
            ...search,
        };
        fetchComments(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                let data = [...res.list];
                data.forEach(item => {
                    delete item['children'];
                });
                setTabData(data);
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const deleteHandle = (item) => {
        setLoading(true);
        updateComments({ id: item.id, delete: true }).then(res => {
            fetchData(pageNum, pageSize, searchParams);
        }).catch(err => message.error(String(err))).finally(() => {
            setLoading(false);
        });
    }

    const onSearchChange = useDebouncedCallback(
        (key, value) => {
            let newParams = { ...searchParams };
            if (key === 'dates') {
                if (value.length == 2) {
                    newParams.start = `${value[0]}T00:00:00Z`;
                    newParams.end = `${value[1]}T23:59:59Z`;
                } else {
                    newParams.start = '';
                    newParams.end = '';
                }
            } else {
                newParams[key] = value;
            }
            setSearchParams(newParams);
            setPageNum(1);
            fetchData(1, pageSize, newParams);
        },
        300
    )

    const reviewHandle = (post) => {
        setCurrPost(post);
        setOpen(true);
    }

    const revokeHandle = (record) => {
        setLoading(true);
        let params = { id: record.id, status: 1, riskReason: '', delete: false };
        updateComments(params).then(res => {
            fetchData(pageNum, pageSize, searchParams);
        }).catch(err => {
            message.error(String(err));
        }).finally(() => {
            setLoading(false);
        });
    }

    const addVirtualComment = () => {
        setCurrComment(null);
        setDrawerOpen(true);
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify="space-between">
                    <Button onClick={addVirtualComment} type="primary" icon={<PlusOutlined />}>Create Virtual Comment</Button>
                    <Space wrap style={{ justifyContent: 'flex-end' }}>
                        <DatePicker.RangePicker
                            onChange={values => onSearchChange('dates', (values ?? []).map(date => dayjs(date).format('YYYY-MM-DD')))} />
                        <Select
                            style={{ width: 160 }}
                            options={PostStatusOptions}
                            placeholder='Comment status'
                            onChange={value => onSearchChange('status', value)}
                            allowClear
                        />
                        <Select
                            style={{ width: 160 }}
                            options={[
                                { key: 1, label: 'Comment', value: '0' },
                                { key: 2, label: 'Reply', value: '1' },
                            ]}
                            placeholder='Comment type'
                            onChange={value => onSearchChange('level', value)}
                            allowClear
                        />
                        <Input
                            placeholder="content search"
                            allowClear
                            onChange={evt => onSearchChange('content', evt.target.value)}
                        />
                        <Input
                            placeholder="user search"
                            allowClear
                            onChange={evt => onSearchChange('userKeyword', evt.target.value)}
                        />
                    </Space>
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table loading={loading} rowKey={(record) => record.id} rowClassName={'table-row'} size='small' dataSource={tabData} columns={tabCols} pagination={false} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>

            <PostReview
                from="comment"
                open={open}
                post={currPost}
                onClose={() => setOpen(false)}
                onUpdate={(() => {
                    fetchData(pageNum, pageSize, searchParams);
                })}
                canEdit={false}
            />

            <VirtualCommentModalView
                defaultComment={currComment}
                open={drawerOpen}
                onClose={() => setDrawerOpen(false)}
                onUpdate={() => {
                    fetchData(pageNum, pageSize, searchParams)
                }} />
        </div>
    )
}

export default CommentsScreen;